/**
 * Session Utilities
 * Helper functions for token estimation and message processing
 */

/**
 * Estimate token count (rough approximation)
 * 1 token ≈ 4 characters for English text
 * @param {string} text - Text to estimate tokens for
 * @returns {number} Estimated token count
 */
export const estimateTokens = (text) => {
  if (!text || typeof text !== 'string') return 0
  return Math.ceil(text.length / 4)
}

/**
 * Calculate total tokens in messages
 * @param {Array} messages - Array of message objects
 * @returns {number} Total token count
 */
export const calculateTokens = (messages) => {
  if (!Array.isArray(messages)) return 0

  return messages.reduce((total, msg) => {
    let content = msg.content || ''
    if (msg.toolCalls) {
      content += JSON.stringify(msg.toolCalls)
    }
    return total + estimateTokens(content)
  }, 0)
}

/**
 * Filter messages by role
 * @param {Array} messages - Array of message objects
 * @param {Array<string>} roles - Roles to keep (e.g., ['user', 'assistant'])
 * @returns {Array} Filtered messages
 */
export const filterMessagesByRole = (messages, roles) => {
  if (!Array.isArray(messages)) return []
  if (!Array.isArray(roles)) return messages

  return messages.filter((msg) => roles.includes(msg.role))
}

/**
 * Format timestamp
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} ISO string
 */
export const formatTimestamp = (timestamp) => {
  return new Date(timestamp).toISOString()
}
